import React from "react";
import InvestigationTable from "../../../components/InvestigatorComponents/Table";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import CAMHeader from "../../../components/Header/CAMHeader";

const Filters = () => {
  return (
    <>
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        <InvestigationTable />
      </InvestigatorContainer>
    </>
  );
};

export default Filters;
